import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Pages
import OrderLookupPage from './pages/Claims/ClaimsPage';
import ThankYouPage from './pages/Shared/ThankYouPage';
import ReturnsPage from './pages/Returns/ReturnsPage';
import OrderHistory from './components/shared/OrderHistory';
import ClaimsPage from './pages/Claims/ClaimsPage';
import SelectOption from './components/shared/SelectOption';
import LandingPage from './pages/Landing/LandingPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SelectOption />} />
      <Route path="/claims" element={<ClaimsPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/returns" element={<ReturnsPage />} />
      <Route path="/orders" element={<OrderHistory />} />
      <Route path="/pages/:slug" element={<LandingPage />} />
    </Routes>
  );
}
